<template>
  <el-container v-if="isReady" class="index-con">
    <el-header class="index-header lyadmin-header">
      <navcon></navcon>
    </el-header>
    <el-container class="main-con">
      <div :class="showclass" class="lyadmin-side">
        <leftnav></leftnav>
      </div>
      <el-container>
        <div class="index-main">
          <div class="full-width">
            <Mutitabs></Mutitabs>
          </div>
        </div>
      </el-container>
    </el-container>
  </el-container>
</template>
<script setup>
    import {ref, onMounted,getCurrentInstance,computed} from 'vue'
    import navcon from '@/components/navcon.vue'
    import leftnav from '@/components/leftnav.vue'
    import Mutitabs from "@/components/mutitabs";
    import {useMutitabsStore} from "@/store/mutitabs";
    import {useSiteThemeStore} from "@/store/siteTheme";
    import {useDictStore} from "@/store/dict";

    const isReady = ref(false)
    let bus = getCurrentInstance().appContext.config.globalProperties.$Bus; // 声明$Bus
    let showclass = ref("asideshow")
    let showtype = ref(false)
    const mutitabsStore =  useMutitabsStore()
    let isMultiTabs = mutitabsStore.isMultiTabs

    const siteThemeStore = useSiteThemeStore()

    const asideshowWidth = computed(()=>{
        return siteThemeStore.menuWidth +'px'
    })

    const dictStore = useDictStore()

    onMounted(async () => {
        try {
            // 等待所有必要的数据加载完成
            await Promise.all([
                dictStore.getDictAll(),
                // 如果有其他需要初始化的数据，也放在这里
            ])
            
            bus.on('toggle', value => {
                if (value) {
                    showclass.value = 'asideshow'
                } else {
                    showclass.value = 'aside'
                }
            })
            
            // 所有数据加载完成后，将 isReady 设置为 true
            isReady.value = true
        } catch (error) {
            console.error('初始化数据失败:', error)
            // 可以在这里添加错误处理逻辑
        }
    })
</script>
<style scoped>
  .main-con{
    width:100%;
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    /*overflow-y: auto;*/
  }
  .hg100{
    height: 100vh !important;
    overflow-y: hidden !important;
  }
  .index-con {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-y: hidden;
  }

  .aside {
    display: flex;
    flex-flow: column;
    flex-shrink: 0;
    transition: width .3s;
    width: 64px !important;
    background-color: var(--l-header-bg);
    margin: 0px;
    box-shadow: 0 0 3px #cccccc;
    /*height: calc(100vh - 60px);*/
  }

  .asideshow {
    display: flex;
    flex-flow: column;
    flex-shrink: 0;
    transition: width .3s;
    width: v-bind(asideshowWidth);
    /*height: calc(100vh - 60px);*/
    background-color: var(--l-header-bg);
    margin: 0px;
    box-shadow: 0 0 1px #cccccc;
  }
  .index-main {
    /*display: block;*/
    /*-webkit-box-flex: 1;*/
    /*-ms-flex: 1;*/
    flex: 1;
    /*-ms-flex-preferred-size: auto;*/
    /*flex-basis: auto;*/
    overflow: auto;
    /*padding: 8px 10px 0 10px;*/
    /*width: 100%;*/
    padding: 0;
    height: 100%;
  }
  .index-header{
    padding: 0px;
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
  .el-main.noPadding{
    padding: 0px !important;
    border-left: 2px solid #333;
  }

  /* 移动端适配 */
  @media screen and (max-width: 768px) {
    .asideshow {
      position: fixed;
      left: -100%;
      z-index: 1000;
      transition: left .3s;
    }
    
    .aside {
      position: fixed;
      left: -100%;
      z-index: 1000;
      transition: left .3s;
    }
    
    .asideshow.mobile-show, .aside.mobile-show {
      left: 0;
    }
    
    .index-main {
      width: 100vw;
      max-width: 100vw;
      margin: 0;
      padding: 0;
    }
    
    .index-header {
      width: 100vw;
      max-width: 100vw;
      padding: 0;
      margin: 0;
    }
    
    .full-width {
      width: 100vw;
      max-width: 100vw;
      padding: 0;
      margin: 0;
    }
    
    .index-con {
      width: 100vw;
      max-width: 100vw;
      overflow-x: hidden;
    }
    
    .main-con {
      width: 100vw;
      max-width: 100vw;
      padding: 0;
      margin: 0;
    }
    
    .el-container {
      width: 100vw;
      max-width: 100vw;
      padding: 0;
      margin: 0;
    }
  }
  
  /* 全宽样式 */
  .full-width {
    width: 100%;
    max-width: 100vw;
    height: 100%;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
</style>